import { useState, useEffect } from 'react'
import api from '@api'

export interface PoliciesList {
  message: string
  complete: boolean
}

export interface PasswordFormatItem {
  regexp: string
  message: string
}

export interface PasswordFormatItemPreCompiled {
  regexp?: RegExp
  message: string
}

export interface PasswordFormats {
  format: PasswordFormatItem[]
}

export interface PasswordPoliciesHook {
  fetchingPolicies: boolean
  setPassword: (password: string) => void
  password: string
  setConfirm: (confirm: string) => void
  confirm: string
  isValid: boolean
  list: PoliciesList[]
}

export default function usePasswordPolicies(): PasswordPoliciesHook {
  const [fetchingPolicies, setFetchingPolicies] = useState(false)
  const [confirm, setConfirm] = useState('')
  const [password, setPassword] = useState('')
  const [format, setFormat] = useState<PasswordFormatItemPreCompiled[]>([])
  const [list, setList] = useState<PoliciesList[]>([])

  useEffect(() => {
    setFetchingPolicies(true)
    api.auth.getPasswordFormat().then(({ format }: PasswordFormats) => {
      setFormat(
        getPolicies(
          format.map((m) => ({
            regexp: new RegExp(m.regexp),
            message: m.message,
          }))
        )
      )
      setFetchingPolicies(false)
    })
  }, [])

  useEffect(() => {
    setList(
      format.map((p) => ({
        complete: p.regexp ? p.regexp.test(password) : password === confirm && !!password.length,
        message: p.message,
      }))
    )
  }, [confirm, password, format])

  return {
    fetchingPolicies,
    setPassword: (password) => setPassword(password),
    password,
    setConfirm: (confirm) => setConfirm(confirm),
    confirm,
    isValid: validPassword(format, password, confirm),
    list,
  }
}

function getPolicies(policy: PasswordFormatItemPreCompiled[]) {
  return policy.concat({
    message: 'Password and password confirmation should match',
  })
}

function validPassword(
  policy: PasswordFormatItemPreCompiled[],
  password = '',
  confirmPassword = ''
) {
  let result = true

  if (password.length && password === confirmPassword) {
    policy.forEach((p) => {
      if (p.regexp && !p.regexp.test(password)) {
        result = false
      }
    })

    return result
  }

  return false
}
